module.exports = __webpack_public_path__ + "media/fonts/suisse-works/SuisseWorks-MediumItalic-637ad8ce5c9f7eabd5341aeab0add6d1.ttf";